// extracted by mini-css-extract-plugin
export default {"links":"links_links__lTvZd","container":"links_container__QOqJJ","linkedCharacteristic":"links_linkedCharacteristic__FsF7I","containerImage":"links_containerImage__TDBHi"};